import React, {useCallback, useEffect, useState} from 'react';
import './styles/App.scss';
import Loading from './elements/Loading';
import FrontPage from './containers/FrontPage';
import {useSelector, useDispatch} from 'react-redux';
import {setTranslation} from './redux/translationSlice';

function App({locale}) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations.value);
  const year = useSelector(state => state.selectedYear.year);

  const questionV = useSelector(state => state.questions.selectedQuestionV);
  
  const [hasData, setHasData] = useState(false);

  const setCurrentTranslation = useCallback(async () => {
    setIsLoading(true);
    const url = `/3m_theme_assets/web_apps/apps/mmmSOSI-2022explorer/data/${year}/language/${locale}/translations.json`;

    const response = await fetch(url);  
    let json=''
    if(response){
      try {
        json = await response.json();   
        setHasData(true)
      } catch (error) {
        console.log('catch this');
        console.log(error);
        setHasData(false)
        dispatch(setTranslation([]));
      }
  }

    // console.log('there');
    // console.log(json);
    dispatch(setTranslation(json));
    setIsLoading(false);
  }, [locale, year]);

  useEffect(() => {
    setCurrentTranslation();
  }, [year]);

// console.log(translations);

  return (
    <div className="mmmdatadxplorer-wrapper">
      {isLoading ? (
        <Loading />
      ) : (
        <FrontPage hasData locale={locale} year={year} translations={translations} />
      )}
    </div>
  );
}

export default App;
